"use client";

import Link from "next/link";
import Image from "next/image";
import { FaChevronDown, FaTimes, FaBars } from "react-icons/fa";
import UserLoginSheet from "../UserLogin/UserLoginSheet";
import SearchCapsule from "../searchCapsule/SearchCapsule";
import DealerDropdown from "../DealerDropdown/DealerDropdown";

export default function DesktopNav({
  navLinks,
  activeDropdown,
  toggleDropdown,
  setActiveDropdown,
  searchQuery,
  setSearchQuery,
  searchResults,
  handleSearchLinkClick,
  searchContainerRef,
  isScrolled,
  setIsMenuOpen,
  isWhiteNavbar
}) {
  const textColor = isWhiteNavbar ? 'text-gray-900' : 'text-white';
  const hoverColor = isWhiteNavbar ? 'hover:text-gray-500' : 'hover:text-gray-300';
  const iconFilter = isWhiteNavbar ? 'brightness-0 pointer-events-none' : 'brightness-0 invert pointer-events-none';
  const logoFilter = isWhiteNavbar ? 'brightness-0' : 'brightness-0 invert';

  return (
    <>
      {/* Desktop View */}
      <div className="hidden navMD:flex items-center h-full w-full max-w-full mx-auto px-15 lg:px-20 relative">

        {/* Right side (RTL start, visual Right): Search Capsule, Doorbell & Login */}
        <div className="flex-1 flex items-center justify-start gap- h-full">
          <UserLoginSheet
            align="right"
            textColor={textColor}
            width={26}
            height={23}
          />
          <button aria-label="اعلانات" className={`flex items-center justify-center w-10 h-10 transition-colors ${hoverColor}`}>
            <Image
              src="/dorbellAlert.svg"
              alt="Alerts"
              width={17}
              height={20}
              className={iconFilter}
            />
          </button>

          <SearchCapsule
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            searchResults={searchResults}
            onLinkClick={handleSearchLinkClick}
            searchContainerRef={searchContainerRef}
            textColor={textColor}

          />

        </div>

        {/* Center: Logo */}
        <div className="flex-shrink-0 flex justify-center items-center px-12 h-full z-10">
          <Link href="/" className="flex items-center" aria-label="صفحه اصلی">
            <Image
              src="/barsavoshRing.png"
              alt="Barsavosh Logo"
              width={53}
              height={53}
              priority
              className={`transition-all duration-500 ease-in-out hover:scale-105 ${logoFilter}`}
            />
          </Link>
        </div>

        {/* Left side (RTL end, visual Left): Menu */}
        <div className="flex-1 flex items-center justify-end gap-6 h-full">
          <button
            onClick={() => setIsMenuOpen(true)}
            className={`flex items-center gap-2 transition-colors font-extralight text-sm ${textColor} ${hoverColor}`}
            aria-label="باز کردن منو"
          >
            منو
            <Image
              src="/hamburgerMenu.svg"
              alt="Menu"
              width={12}
              height={10}
              className={iconFilter}
            />
          </button>
        </div>
      </div>
    </>
  );
}

